import { useQuery } from "@tanstack/react-query";
import { externalGet } from "@shared/api/clients";

export interface CepApiResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

const cleanCep = (cep: string): string => cep.replace(/\D/g, "");

const fetchCep = async (cep: string): Promise<CepApiResponse> => {
  return externalGet<CepApiResponse>(`https://viacep.com.br/ws/${cep}/json/`);
};

export const useCepQuery = (cep: string) => {
  const cleaned = cleanCep(cep);

  return useQuery<CepApiResponse>({
    queryKey: ["cep", cleaned],
    queryFn: () => fetchCep(cleaned),
    enabled: cleaned.length === 8,
    retry: false,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
  });
};
